export default __webpack_public_path__ + "static/media/imc-inner-4.3151fec0.mp4";